(function() {
  const ANIMATION_SELECTOR = '[data-animate]';
  const STAGGER_CHILD_SELECTOR = '[data-animate-child]';
  const VISIBLE_CLASS = 'is-visible';
  const STAGGER_STEP = 140;
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  const reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);
  const observedElements = new WeakSet();

  const observer = new IntersectionObserver(handleIntersections, {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.15
  });

  function handleIntersections(entries) {
    entries.forEach((entry) => {
      const element = entry.target;

      if (entry.isIntersecting) {
        revealElement(element);

        if (shouldAnimateOnce(element)) {
          observer.unobserve(element);
        }

        return;
      }

      if (!shouldAnimateOnce(element)) {
        hideElement(element);
      }
    });
  }

  function shouldAnimateOnce(element) {
    return element.dataset.animateOnce !== 'false';
  }

  function setElementDelay(element) {
    const delay = parseDelay(element.dataset.animateDelay);
    element.style.setProperty('--animate-delay', `${delay}ms`);
  }

  function setStaggerDelays(container) {
    const baseDelay = parseDelay(container.dataset.animateDelay);
    const staggerStep = parseDelay(container.dataset.animateStagger) || STAGGER_STEP;
    const staggerItems = container.querySelectorAll(STAGGER_CHILD_SELECTOR);

    staggerItems.forEach((item, index) => {
      item.style.setProperty('--animate-delay', `${baseDelay + index * staggerStep}ms`);
    });
  }

  function parseDelay(rawDelay) {
    const delay = Number.parseInt(rawDelay, 10);
    return Number.isNaN(delay) ? 0 : Math.max(delay, 0);
  }

  function revealElement(element) {
    if (element.dataset.animate === 'stagger-fade-up') {
      setStaggerDelays(element);
    } else {
      setElementDelay(element);
    }

    element.classList.add(VISIBLE_CLASS);
  }

  function hideElement(element) {
    element.classList.remove(VISIBLE_CLASS);
  }

  function prepareElement(element) {
    if (element.dataset.animate === 'stagger-fade-up') {
      setStaggerDelays(element);
      return;
    }

    setElementDelay(element);
  }

  function observeAnimations(scope) {
    const elements = getAnimationElements(scope);

    elements.forEach((element) => {
      if (observedElements.has(element)) return;

      prepareElement(element);

      if (reducedMotion.matches) {
        revealElement(element);
        observedElements.add(element);
        return;
      }

      observer.observe(element);
      observedElements.add(element);
    });
  }

  function initAnimations(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    observeAnimations(scope);
  }

  function getAnimationElements(scope) {
    if (scope === document) {
      return Array.from(document.querySelectorAll(ANIMATION_SELECTOR));
    }

    const elements = Array.from(scope.querySelectorAll(ANIMATION_SELECTOR));

    if (typeof scope.matches === 'function' && scope.matches(ANIMATION_SELECTOR)) {
      elements.unshift(scope);
    }

    return elements;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAnimations(document);
    });
  } else {
    initAnimations(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAnimations(event.target);
  });

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', function(event) {
      document.querySelectorAll(ANIMATION_SELECTOR).forEach((element) => {
        if (event.matches) {
          revealElement(element);
          observer.unobserve(element);
          return;
        }

        if (observedElements.has(element) && !element.classList.contains(VISIBLE_CLASS)) {
          observer.observe(element);
        }
      });
    });
  }
})();
